import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import flag from '@baseImg/icons/voltage-icon.webp';

const BG = {
	page: 'Shopiko',
	brandColor: 'color-brand-green-400',
	title: '<span class="nowrap">Shopiko. Онлайн</span> <span class="nowrap">магазин, готов</span> <span class="nowrap">за продажби</span>',
	list:
	  [
		  'Готови дизайни',
		  'Над 20 разплащателни метода',
		  'Интеграция с български и международни куриери'
	  ],
	additionalText: '',
	priceServiceId: 'plan_gomba_shop_01',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: 'Тествай безплатно за 14 дни',
	buttonAction: 'StartShopikoTrial',
	buttonParams: [
		'#contextCart#'
	],
	ButtonModal: '',
	infoBar: {
		text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Flash Sale! Запази .BG и .EU заедно и вземи над 50% отстъпка до 11 ноември!',
		buttonText: 'Поръчай',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'Shopiko',
	brandColor: 'color-brand-green-400',
	title: '<span class="nowrap">Shopiko. An online</span> <span class="nowrap">store, ready</span> <span class="nowrap">to sell.</span>',
	list:
	  [
		  'Ready-to-Use design templates',
		  '20+ types of payment methods',
		  'Integrated shipping with local and international couriers'
	  ],
	additionalText: '',
	priceServiceId: 'plan_gomba_shop_01',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: 'Try free for 14 days',
	buttonAction: 'StartShopikoTrial',
	buttonParams: [
		'#contextCart#'
	],
	ButtonModal: '',
	infoBar: {
		text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Flash Sale! Get .BG & .EU together and save over 50% until November 11!',
		buttonText: 'Order',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];